export default function genererCritereRecherche() {
  return {
    tiers: [],
    dateComptable: {
      dateDebut: null,
      dateFin: null,
    },
    journaux: [],
    comptesComptables: [],
    agencesIds: [],
    valide: null,
    societeId: null,
    typesEcriture: [],
  };
}
